import './less/main.less'
import './polyfills/is_array.js'
import './stores/chart_store.js'
import renderChart from './render_chart'

window.renderChart = renderChart



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/